<template>
  <div :class="$style.button">
    <div
      v-if="small"
      :class="[
        $style.small,
        readonly ? $style.readonly : '',
        outerShadow ? $style.outer_shadow : '',
        bold ? $style.bold : '',
      ]"
      :style="{...styles}"
      @click="() => $emit('onClick')"
    >
      <div
        v-if="icon"
        :class="$style.icon"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.3125 4.6875L12 6L7.3125 7.3125L6 12L4.6875 7.3125L0 6L4.6875 4.6875L6 0L7.3125 4.6875Z"
            fill="white"
          />
        </svg>
      </div>
      {{ text }}
      <div
        v-if="icon"
        :class="$style.icon"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.3125 4.6875L12 6L7.3125 7.3125L6 12L4.6875 7.3125L0 6L4.6875 4.6875L6 0L7.3125 4.6875Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
    <div
      v-else
      :class="$style.normal"
      @click="() => $emit('onClick')"
    >
      <div :class="$style.text">
        {{ locales('pricing_get_the_deal_btn') }}
      </div>
      <div :class="$style.arrow_ic">
        <svg
          width="10"
          height="17"
          viewBox="0 0 10 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.833986 0.833374L8.33398 8.33337L0.833986 15.8334"
            stroke="white"
            stroke-width="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    small: { type: Boolean, reqired: false, default: true },
    readonly: { type: Boolean, reqired: false, default: false },
    styles: { type: Object, required: false, default: () => {} },
    icon: { type: Boolean, reqired: false, default: false },
    bold: { type: Boolean, reqired: false, default: false },
    outerShadow: { type: Boolean, reqired: false, default: false },
    text: { type: String, reqierd: false, default: 'Black weeks' },
  },
  emits: { onClick: null },
  data() {
    return {
      locales: __,
    };
  },
};
</script>

<style module lang="less">
  @import '../../../../less/_mixins.less';
  @import '../../../../less/_fonts.less';
  @import '../../../../less/_variables.less';

 .button {
  .small {
    .FontLatoRegular;
    font-size: 10px;
    color: #fff;
    padding: 4px 12px;
    border-radius: 24px;
    background: #212121;
    box-shadow: 0 2px 4px 0 rgba(255, 255, 255, 0.25) inset;
    display: inline-flex;
    padding: 4px 12px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    white-space: nowrap;

    .icon {
      display: flex;
    }

    &.bold {
      .FontLatoBold;
    }

    &:active {
      box-shadow: 0 2px 4px 0 rgba(255, 255, 255, 0.25) inset;
      color: rgba(255, 255, 255, 0.60);
    }

    &.readonly {
      pointer-events: none;
    }

    &.outer_shadow {
      box-shadow: 0.4px 0.4px 0 0 rgba(241, 245, 251, 0.40) inset, 0 1px 5px 0 rgba(14, 71, 135, 0.40), 0 2px 4px 0 rgba(255, 255, 255, 0.25) inset;
    }

    &:hover {
      cursor: pointer;
      box-shadow: 0 -5px 6px 0 rgba(21, 101, 192, 0.80) inset, 0 -1px 2px 0 #FFF inset;
    }
  }

  .normal {

    padding: 8px 12px;
    display: flex;

    border-radius: 66px;
    background: #000;
    box-shadow: 0 4px 25px 0 rgba(21, 101, 192, 0.50);
    color: #fff;
    white-space: nowrap;

    .text {
      .FontLatoBold;
      margin-right: 16px;
    }

    .arrow_ic {
      display: flex;
    }

    &:hover {
      border-radius: 66px;
      background: #000;
      box-shadow: 0 4px 25px 0 #1565C0;
      cursor: pointer;
    }

    &:active {
      border-radius: 66px;
      background: #000;
      box-shadow: 0 4px 25px 0 rgba(21, 101, 192, 0.50);

      .text {
        color: rgba(255, 255, 255, 0.60);
      }

      .arrow_ic {
        svg {
          color: rgba(255, 255, 255, 0.60);
        }
      }
    }
  }
 }
</style>
